import { render, staticRenderFns } from "./GrowerTags.vue?vue&type=template&id=442e4391&scoped=true&"
import script from "./GrowerTags.vue?vue&type=script&lang=js&"
export * from "./GrowerTags.vue?vue&type=script&lang=js&"
import style0 from "./GrowerTags.vue?vue&type=style&index=0&id=442e4391&prod&lang=css&"
import style1 from "./GrowerTags.vue?vue&type=style&index=1&id=442e4391&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e4391",
  null
  
)

export default component.exports